import { Center, Loader } from "@mantine/core";
import PreviewHeader from "components/header/PreviewHeader";
import AdminDebitJournalPreview from "pages/admin/dataEntry/AdminDebitJournalPreview";
import { useSearchParams } from "react-router-dom";

const PrintDbJnl: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  if (!id)
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  return (
    <div className="inner-container">
      <PreviewHeader />

      <AdminDebitJournalPreview id={Number(id)} />
    </div>
  );
};

export default PrintDbJnl;
